/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ContentGraphActor = zod.object({
  actorType: zod.enum(['USER', 'SYSTEM', 'GROUP', 'PUBLIC', 'AGENT']),
  firstName: zod.string().nullable(),
  id: zod.string().nullable(),
  lastName: zod.string().nullable(),
  name: zod.string(),
  profileImage: zod
    .object({
      large: zod
        .object({
          contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          url: zod.string().nullable(),
        })
        .nullable(),
      medium: zod
        .object({
          contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          url: zod.string().nullable(),
        })
        .nullable(),
      original: zod
        .object({
          contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          url: zod.string().nullable(),
        })
        .nullable(),
      small: zod
        .object({
          contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          url: zod.string().nullable(),
        })
        .nullable(),
      xsmall: zod
        .object({
          contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
          url: zod.string().nullable(),
        })
        .nullable(),
    })
    .nullable(),
  uuid: zod.uuid().describe('UUID v4 identifier'),
});

export type ContentGraphActor = zod.input<typeof ContentGraphActor>;
export type ContentGraphActorOutput = zod.output<typeof ContentGraphActor>;
